export type MobilePlatform = "ios" | "android";

const ANDROID_PATTERN = /android/i;
const IOS_DEVICE_PATTERN = /iphone|ipad|ipod/i;
const MAC_PATTERN = /macintosh/i;

/**
 * The phone or tablet platform a browser is running on, or `null` on a desktop.
 *
 * iPadOS Safari asks for the desktop site by default and reports itself as a Mac, so a "Macintosh" with
 * a touch screen is an iPad.
 */
export function detectMobilePlatform(
  userAgent: string,
  maxTouchPoints = 0,
): MobilePlatform | null {
  if (ANDROID_PATTERN.test(userAgent)) return "android";
  if (IOS_DEVICE_PATTERN.test(userAgent)) return "ios";
  if (MAC_PATTERN.test(userAgent) && maxTouchPoints > 1) return "ios";
  return null;
}
